import React from 'react';
import RadioBlock from "../radio-block/RadioBlock";
import PropTypes from 'prop-types';
import transfer from '../../../../assets/images/transfer.png'

export const Transfer = (props) => {
  const {paymentType, ...other} = props;

  return (
    <RadioBlock
      {...other}
      checked={paymentType === "TransferKhipu"}
      className="my-2"
      name="online-payment"
      id="radio-transf"
      value="TransferKhipu"
      label={<span><b>Pago en línea</b> con transferencia bancaria con khipu</span>}
      end={<span className="flex-center"><img src={transfer} alt=""/></span>}
    />
  );
};

Transfer.propTypes = {
  paymentType: PropTypes.string
}

Transfer.defaultProps = {
  paymentType: ""
}

export default Transfer;
